export interface CompositorFont {
  family: string
  weights: string[]
  category: "sans-serif" | "serif" | "monospace" | "display"
}

export const COMPOSITOR_FONTS: CompositorFont[] = [
  // Sans-serif
  { family: "Inter", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "DM Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Poppins", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Roboto", weights: ["100", "300", "400", "500", "700", "900"], category: "sans-serif" },
  { family: "Open Sans", weights: ["300", "400", "500", "600", "700", "800"], category: "sans-serif" },
  { family: "Montserrat", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Lato", weights: ["100", "300", "400", "700", "900"], category: "sans-serif" },
  { family: "Nunito", weights: ["200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Outfit", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Plus Jakarta Sans", weights: ["200", "300", "400", "500", "600", "700", "800"], category: "sans-serif" },
  { family: "Work Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Space Grotesk", weights: ["300", "400", "500", "600", "700"], category: "sans-serif" },
  { family: "Raleway", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Oswald", weights: ["200", "300", "400", "500", "600", "700"], category: "sans-serif" },
  { family: "Noto Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  { family: "Noto Sans JP", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"], category: "sans-serif" },
  // Serif
  { family: "Playfair Display", weights: ["400", "500", "600", "700", "800", "900"], category: "serif" },
  { family: "Instrument Serif", weights: ["400"], category: "serif" },
  { family: "Libre Baskerville", weights: ["400", "700"], category: "serif" },
  { family: "Merriweather", weights: ["300", "400", "700", "900"], category: "serif" },
  // Monospace
  { family: "JetBrains Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800"], category: "monospace" },
  { family: "Fira Code", weights: ["300", "400", "500", "600", "700"], category: "monospace" },
  { family: "Space Mono", weights: ["400", "700"], category: "monospace" },
  { family: "Source Code Pro", weights: ["200", "300", "400", "500", "600", "700", "800", "900"], category: "monospace" },
  // Display
  { family: "Pacifico", weights: ["400"], category: "display" },
]

const loadedFonts = new Set<string>()

export async function loadFont(family: string, weight = "400"): Promise<void> {
  const key = `${family}:${weight}`
  if (loadedFonts.has(key)) return

  try {
    const url = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@${weight}&display=swap`
    const css = await fetch(url).then((r) => r.text())
    const srcMatch = css.match(/url\(([^)]+)\)/)
    if (!srcMatch) return

    const fontFace = new FontFace(family, `url(${srcMatch[1]})`, { weight, style: "normal" })
    await fontFace.load()
    document.fonts.add(fontFace)
    loadedFonts.add(key)
  } catch {
    // Font loading failure is non-fatal — fallback to system font
  }
}

export async function preloadDefaultFont(): Promise<void> {
  await loadFont("Inter", "400")
}
